var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("section-hero", {
        attrs: { first: "", "section-name": "jobs_hero" },
        on: {
          scroll: function ($event) {
            return _vm.$router.push({ hash: "#jobs" })
          },
        },
      }),
      _vm._v(" "),
      _vm._l(_vm.$store.state.jobs, function (job) {
        return _c("job-offer", { key: job.id, attrs: { job: job } })
      }),
      _vm._v(" "),
      _c("section-references"),
      _vm._v(" "),
      _c("section-contact"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }